// extracted by mini-css-extract-plugin
export default {"container":"DescriptionController_container__YYz3S","text":"DescriptionController_text__FrrOV"};